import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/index'
import 'normalize.css/normalize.css'
import './assets/css/index.scss'
import scrollTop from './mixins/scrollTop'
import tools from './assets/js/tools/index'

Vue.mixin(scrollTop)
Vue.prototype.$tools = tools

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
